"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _useTrackingLayer = _interopRequireDefault(require("../utils/useTrackingLayer"));

var _DirectLink = _interopRequireDefault(require("./DirectLink.css"));

var _radium = _interopRequireDefault(require("radium"));

var _directLink_utils = require("./direct-link_utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DirectLink = function DirectLink(_ref) {
  var isRedirection = _ref.isRedirection,
      isSubmission = _ref.isSubmission,
      email = _ref.email,
      url = _ref.url,
      jump = _ref.jump,
      tracking = _ref.tracking;
  var history = (0, _reactRouterDom.useHistory)();
  (0, _useTrackingLayer.default)(tracking, email);
  var hasFired = (0, _react.useRef)(false);

  if (!hasFired.current) {
    var linkOut = (0, _directLink_utils.buildFullLink)(url, tracking);
    var jumpBehind = (0, _directLink_utils.buildFullLink)(jump, tracking); // If they were NOT placed here through redirection, but there is a click event to use.

    if (!isRedirection || isSubmission) {
      var newTab = window.open();
      newTab.location.href = linkOut;

      if (jumpBehind && jumpBehind !== 'N/A') {
        window.location.href = jumpBehind;
        hasFired.current = true;
        return;
      }

      ;
      history.push('/verticals');
      hasFired.current = true;
      return;
    } else {
      window.location.href = linkOut;
      hasFired.current = true;
    }
  }

  ;
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "directing-to-offer",
    style: _DirectLink.default.main
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _DirectLink.default.header
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: _DirectLink.default.text
  }, "...Offers coming your way!")));
};

var _default = (0, _radium.default)(DirectLink);

exports.default = _default;

//# sourceMappingURL=DirectLink.jsx.map